import React from 'react';
import { 
  LightbulbIcon, 
  Apple, 
  Droplets, 
  Clock, 
  Scale, 
  UtensilsCrossed, 
  Coffee, 
  Salad, 
  Rocket 
} from 'lucide-react';

const NutritionTipsSidebar = () => {
  const tips = [
    {
      icon: Apple,
      title: 'Питайтесь разнообразно',
      description: 'Включайте в рацион продукты всех групп: овощи, фрукты, белки, злаки и полезные жиры.'
    },
    {
      icon: Droplets,
      title: 'Пейте достаточно воды',
      description: 'Выпивайте не менее 1.5-2 литров воды в день. Это поможет контролировать голод и ускорит метаболизм.'
    },
    {
      icon: Clock,
      title: 'Соблюдайте режим',
      description: 'Старайтесь есть примерно в одно и то же время. Это стабилизирует уровень сахара в крови.'
    },
    {
      icon: Scale,
      title: 'Контролируйте порции',
      description: 'Используйте меньшую посуду и следите за размером порций даже при здоровом питании.'
    },
    {
      icon: UtensilsCrossed,
      title: 'Готовьте дома',
      description: 'Домашняя еда позволяет контролировать состав и калорийность блюд.'
    },
    {
      icon: Coffee,
      title: 'Осторожно со скрытыми калориями',
      description: 'Напитки, соусы и заправки часто содержат много скрытых калорий и сахара.'
    },
    {
      icon: Salad,
      title: 'Больше клетчатки',
      description: 'Продукты с высоким содержанием клетчатки повышают чувство сытости и улучшают пищеварение.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <LightbulbIcon className="w-5 h-5 mr-2 text-emerald-500" />
        Советы по правильному питанию
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-emerald-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-100 dark:border-emerald-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <Rocket className="w-5 h-5 text-emerald-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-emerald-700 dark:text-emerald-300 mb-2">
              Дневник питания
            </h4>
            <p className="text-xs text-emerald-600 dark:text-emerald-400 mb-3">
              Ведение дневника питания повышает эффективность снижения веса на 80%. Записывайте всё, что вы едите и пьёте в течение дня.
            </p>
            <button className="w-full py-1.5 text-xs bg-emerald-500 text-white rounded hover:bg-emerald-600 transition-colors">
              Скачать шаблон дневника
            </button>
          </div>
        </div>
      </div>
      
      {/* Специальные советы для россиян */}
      <div className="mt-5 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-2">
          Особенности питания в России
        </h4>
        <ul className="text-xs text-blue-600 dark:text-blue-400 space-y-2">
          <li className="flex items-start">
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-blue-500 mt-1.5 mr-1.5 flex-shrink-0"></span>
            <span>Добавляйте в рацион сезонные отечественные овощи: капусту, свеклу, морковь, кабачки — они доступны и полезны.</span>
          </li>
          <li className="flex items-start">
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-blue-500 mt-1.5 mr-1.5 flex-shrink-0"></span>
            <span>Используйте гречку, овсянку и другие крупы как источник сложных углеводов и клетчатки.</span>
          </li>
          <li className="flex items-start">
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-blue-500 mt-1.5 mr-1.5 flex-shrink-0"></span>
            <span>Нежирные кисломолочные продукты (кефир, творог, ряженка) — хороший источник белка и кальция.</span>
          </li>
          <li className="flex items-start">
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-blue-500 mt-1.5 mr-1.5 flex-shrink-0"></span>
            <span>В зимний период обогащайте рацион витаминами из квашеной капусты, замороженных ягод и зелени.</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default NutritionTipsSidebar;